import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Form',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Form-Covid/Index.vue')
  }, 
  {
    path: '/error-404',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/Error-404/Index.vue')
  }, 
  {
    path: '*',
    redirect: '/error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
